
import React, { lazy } from "react";
import {
  SET_FILTER_LEAGUE,
} from "@/lib/redux/reducers/actionTypes";
import { useDispatch } from 'react-redux';
const HeaderFixtureLichThiDau = lazy(() => import("@/components/client/HeaderFixtureLichThiDau"));
const LichThiDau = lazy(() => import("@/components/client/LichThiDau"));

const LichThiDauPlugin = ({league}) => {
  
  const dispatch = useDispatch();
  if (league !== '') {
    dispatch({ type: SET_FILTER_LEAGUE, payload: league });
  }
  const className = league !== '' && 'hidden';
  return (
    <div className="mt-4">
      <HeaderFixtureLichThiDau className={className} leagueAttr={league}/>
      <LichThiDau />
    </div>
  );
};

export default React.memo(LichThiDauPlugin);